// LiveStreamManager.jsx
import React, { useState, useEffect } from "react";
import { useAuth } from "../../lib/auth"; // Assurez-vous que ce hook est configuré
import "../../styles/LiveStreamManager.css"; // Fichier CSS pour styliser le composant

const LiveStreamManager = () => {
  const { isAuthenticated, user } = useAuth();
  const [liveStream, setLiveStream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // États du formulaire
  const [streamUrl, setStreamUrl] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  // Récupération de la diffusion live via GET /api/live-stream
  const fetchLiveStream = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://api.nms06.com/api/live-stream", {
        headers: { Accept: "application/json" },
      });
      if (response.ok) {
        const data = await response.json();
        console.log("Données du live stream reçues :", data);
        setLiveStream(data);
        // Pré-remplissage du formulaire pour la mise à jour
        setStreamUrl(data.stream_url || "");
        setTitle(data.title || "");
        setDescription(data.description || "");
        setStatus(data.status || "");
      } else if (response.status === 404) {
        console.log("Aucune diffusion live trouvée.");
        setLiveStream(null);
      } else {
        setError("Erreur lors de la récupération du live stream, statut " + response.status);
      }
    } catch (err) {
      setError("Erreur lors de la récupération du live stream : " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveStream();
  }, []);

  // Créer une diffusion live via POST /api/live-stream
  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.nms06.com/api/live-stream", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stream_url: streamUrl, title, description, status }),
      });
      if (response.ok) {
        const data = await response.json();
        setLiveStream(data);
        setError("");
        console.log("Diffusion live créée :", data);
      } else {
        setError("Erreur lors de la création du live stream, statut " + response.status);
      }
    } catch (err) {
      setError("Erreur lors de la création du live stream : " + err.message);
    }
  };

  // Mettre à jour la diffusion live via PUT /api/live-stream/:id
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!liveStream || !liveStream.id) {
      setError("Aucune diffusion live à mettre à jour.");
      return;
    }
    try {
      const response = await fetch(`https://api.nms06.com/api/live-stream/${liveStream.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stream_url: streamUrl, title, description, status }),
      });
      if (response.ok) {
        await fetchLiveStream();
        setError("");
        console.log("Diffusion live mise à jour avec succès.");
      } else {
        setError("Erreur lors de la mise à jour du live stream, statut " + response.status);
      }
    } catch (err) {
      setError("Erreur lors de la mise à jour du live stream : " + err.message);
    }
  };

  // Supprimer la diffusion live via DELETE /api/live-stream/:id
  const handleDelete = async () => {
    if (!liveStream || !liveStream.id) {
      setError("Aucune diffusion live à supprimer.");
      return;
    }
    try {
      const response = await fetch(`https://api.nms06.com/api/live-stream/${liveStream.id}`, {
        method: "DELETE",
      });
      if (response.ok) {
        setLiveStream(null);
        setStreamUrl("");
        setTitle("");
        setDescription("");
        setStatus("");
        setError("");
        console.log("Diffusion live supprimée avec succès.");
      } else {
        setError("Erreur lors de la suppression du live stream, statut " + response.status);
      }
    } catch (err) {
      setError("Erreur lors de la suppression du live stream : " + err.message);
    }
  };

  return (
    <div className="live-stream-manager">
      <h1>Gestion de la Diffusion Live</h1>

      {loading && <p>Chargement...</p>}
      {error && <p className="error">{error}</p>}

      {liveStream ? (
        <div className="live-details">
          <h2>Détails de la diffusion live</h2>
          <p><strong>Stream URL:</strong> {liveStream.stream_url}</p>
          <p><strong>Title:</strong> {liveStream.title}</p>
          <p><strong>Description:</strong> {liveStream.description}</p>
          <p><strong>Status:</strong> {liveStream.status}</p>
          <div className="action-buttons">
            <button onClick={handleUpdate}>Modifier</button>
            <button onClick={handleDelete} className="delete-button">Supprimer</button>
          </div>
        </div>
      ) : (
        <p>Aucune diffusion live trouvée.</p>
      )}

      {isAuthenticated && user?.role === "admin" && (
        <div className="live-stream-form">
          <h2>{liveStream ? "Mettre à jour la diffusion live" : "Créer une nouvelle diffusion live"}</h2>
          <form onSubmit={liveStream ? handleUpdate : handleCreate}>
            <div>
              <label>
                Stream URL:
                <input
                  type="text"
                  value={streamUrl}
                  onChange={(e) => setStreamUrl(e.target.value)}
                  required
                />
              </label>
            </div>
            <div>
              <label>
                Title:
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </label>
            </div>
            <div>
              <label>
                Description:
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </label>
            </div>
            <div>
              <label>
                Status:
                <input
                  type="text"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  required
                />
              </label>
            </div>
            <button type="submit">
              {liveStream ? "Mettre à jour" : "Créer"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default LiveStreamManager;
